import React from "react";
export default class PartyResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        let alliances = this.props.data;
        return (
            <tbody>
                <tr>
                    {
                        Object.keys(alliances).length > 0 ? Object.keys(alliances).map((a_key) => {
                            if (alliances[a_key]) {
                                let pncls = alliances[a_key]['gainOrLoss'] ? (alliances[a_key]['gainOrLoss'] < 0 ? "textred" : "textgreen") : "textgreen";
                                let totalSeats = alliances[a_key]['totalSeats'] ? ((alliances[a_key]['totalSeats'] + "").length >= 2 ? alliances[a_key]['totalSeats'] : '0' + alliances[a_key]['totalSeats']) : 0;
                                let gainOrLoss = alliances[a_key]['gainOrLoss'] ? ((alliances[a_key]['gainOrLoss'] + "").length >= 2 ? alliances[a_key]['gainOrLoss'] : '0' + alliances[a_key]['gainOrLoss']) : 0;
                                return (<td key={Math.random()}>
                                    <h6 className="result_count">
                                        {totalSeats}
                                        {
                                            this.props.isremove != 1 ? <span className={pncls + " result_count_plusminus "}>
                                                {"(" + gainOrLoss + ")"}
                                            </span> : ""
                                        }

                                    </h6>
                                </td>)
                            }

                        }) : ""}

                </tr>
            </tbody>
        )
    }

}
